import axios from "axios";

// Same-origin in prod (nginx on stux.info proxies /api -> api:8000)
// and in dev (vite.config.ts proxies the same paths).
export const api = axios.create({
  baseURL: "/api",
  withCredentials: true,
});

export const authBase = "/auth";
